import React from 'react';

import { Row, Col, Form } from "react-bootstrap";

const EmergencyContact = ({contact, index, onChangeInput}) => {

    return ( 
        <>          
        <Form.Control type="hidden" name={`emergencyContacts.${index}.id`} placeholder="Nombre de Contacto" value={contact.id} onChange={onChangeInput}/>
            <Form.Group as={Row} controlId="formHorizontalPassword">
                <Form.Label column sm={2}>
                    Nombre
                </Form.Label>
                <Col sm={10}>
                <Form.Control type="text" name={`emergencyContacts.${index}.fullName`} placeholder="Nombre de Contacto" value={contact.fullName} onChange={onChangeInput}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalPassword">
                <Form.Label column sm={2}>
                    Email
                </Form.Label>
                <Col sm={10}>
                <Form.Control type="email" name={`emergencyContacts.${index}.email`} placeholder="Email" value={contact.email}  onChange={onChangeInput}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalPassword">
                <Form.Label column sm={2}>
                    Teléfono Fijo
                </Form.Label>
                <Col sm={4}>
                <Form.Control type="text" name={`emergencyContacts.${index}.phone`} placeholder="Teléfono Fijo" value={contact.phone} onChange={onChangeInput}/>
                </Col>

                <Form.Label column sm={2}>
                    Teléfono Celular
                </Form.Label>
                <Col sm={4}>
                <Form.Control type="text" name={`emergencyContacts.${index}.cellphone`} placeholder="Teléfono Celular" value={contact.cellphone} onChange={onChangeInput}/>
                </Col>
            </Form.Group> 
        </>
     );
}
 
export default EmergencyContact;